export const requestToken = (source) => ({
  type: 'REQUEST_TOKEN',
  source,
})

export const receiveToken = (source, token) => ({
  type: 'RECEIVE_TOKEN',
  source,
  token,
})